<div class="container-fluid">
  <div class="row manageaccount mt-3">
    <div class="col-md-12 my-auto">
      <div class="d-flex align-items-center justify-content-between">
        <h1 class="fs-4 fw-bold">Add New Vehicle</h1>
        <button
          class="btn btn-dark btn-sm"
          mat-raised-button
          matTooltip="Back"
          matTooltipPosition="left"
          (click)="backTo()"
        >
          <i class="fa-solid fa-arrow-left"></i>
        </button>
      </div>
      <nav class="breadcrumbMaine" aria-label="breadcrumb mb-0">
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item" routerLink="/superAdmin/manageVehicle">
            Manage Vehicle
          </li>
          <li class="breadcrumb-item active" aria-current="page">
            Add New Vehicle
          </li>
        </ol>
      </nav>
    </div>
  </div>

  <div class="row mt-3">
    <div class="col-xl-12">
      <form
        [formGroup]="addNewVehicle"
        (ngSubmit)="addNewVehicleSubmit()"
        enctype="multipart/form-data"
      >
        <div class="contentbox">
          <div class="row account mb-3">
            <div class="col-lg-3 col-xl-3 col-sm-6 col-12 col-md-4">
              <div class="form-group accountsinp mb-3">
                <label for=""
                  >Vehicle Number<sup class="text-danger">*</sup></label
                >
                <input
                  type="text"
                  id="vehicleNumberctrl"
                  class="form-control shadow-none"
                  placeholder="Enter Vehicle Number"
                  formControlName="vehicleNumber"
                />
              </div>
            </div>
            <div class="col-lg-3 col-xl-3 col-sm-6 col-12 col-md-4">
              <div class="form-group accountsinp mb-3">
                <label for=""
                  >Vehicle Type<sup class="text-danger">*</sup></label
                >
                <input
                  type="text"
                  id="vehicleTypectrl"
                  class="form-control shadow-none"
                  placeholder="Enter Vehicle Type"
                  formControlName="vehicleType"
                  [matAutocomplete]="autoVehicleType"
                />
                <mat-autocomplete
                  autoActiveFirstOption
                  #autoVehicleType="matAutocomplete"
                >
                  <mat-option
                    *ngFor="let option of filteredVehicleTypes | async"
                    [value]="option"
                  >
                    {{ option }}
                  </mat-option>
                </mat-autocomplete>
              </div>
            </div>

            <div class="col-lg-3 col-xl-3 col-sm-6 col-12 col-md-4">
              <label>Ownership<sup class="text-danger">*</sup></label>
              <select class="form-control" formControlName="ownership">
                <option disabled hidden value="">-- Select --</option>
                <option value="own">Own</option>
                <option value="rented">Rented</option>
              </select>
            </div>
            <div class="col-lg-3 col-xl-3 col-sm-6 col-12 col-md-4">
              <div class="form-group custom-select accountsinp mb-2">
                <label for="transporterCtrl">Transporter Name</label>

                <input
                  type="text"
                  matInput
                  id="transporterCtrl"
                  placeholder="Search Transporter"
                  [matAutocomplete]="autoTransporter"
                  formControlName="transporter"
                  class="form-control shadow-none"
                />

                <mat-autocomplete
                  #autoTransporter="matAutocomplete"
                  [displayWith]="displayTransporter"
                  (optionSelected)="onSelectTransporter($event.option.value)"
                >
                  <mat-option
                    *ngFor="let t of filteredTransporterList | async"
                    [value]="t"
                  >
                    {{ t.full_name }}
                  </mat-option>
                </mat-autocomplete>
              </div>
            </div>

            <div class="col-lg-3 col-xl-3 col-sm-6 col-12 col-md-4">
              <div class="form-group accountsinp mb-3">
                <label for="">Driver Name</label>
                <input
                  type="text"
                  id="driverNamectrl"
                  class="form-control shadow-none"
                  placeholder="Enter Driver Name"
                  formControlName="driverName"
                  [matAutocomplete]="autoDriverName"
                />
                <mat-autocomplete
                  autoActiveFirstOption
                  #autoDriverName="matAutocomplete"
                >
                  <mat-option
                    *ngFor="let option of filteredDriverName | async"
                    [value]="option"
                  >
                    {{ option }}
                  </mat-option>
                </mat-autocomplete>
              </div>
            </div>

            <div class="col-lg-3 col-xl-3 col-sm-6 col-12 col-md-4">
              <div class="form-group accountsinp mb-3">
                <label for="">Maker Name</label>
                <input
                  type="text"
                  id="makerNamectrl"
                  class="form-control shadow-none"
                  placeholder="Enter Maker Name"
                  formControlName="makerName"
                />
              </div>
            </div>
            <div class="col-lg-3 col-xl-3 col-sm-6 col-12 col-md-4">
              <div class="form-group accountsinp mb-3">
                <label for="">Chassis Number</label>
                <input
                  type="text"
                  id="chassisNumberctrl"
                  class="form-control shadow-none"
                  placeholder="Enter Chassis Number"
                  formControlName="chassisNumber"
                />
              </div>
            </div>
            <div class="col-lg-3 col-xl-3 col-sm-6 col-12 col-md-4">
              <div class="form-group accountsinp mb-3">
                <label for="">Engine Number</label>
                <input
                  type="text"
                  id="engineNumberctrl"
                  class="form-control shadow-none"
                  placeholder="Enter Engine Number"
                  formControlName="engineNumber"
                />
              </div>
            </div>
            <div class="col-lg-3 col-xl-3 col-sm-6 col-12 col-md-4">
              <div class="form-group accountsinp mb-3">
                <label for="">Permit Number</label>
                <input
                  type="text"
                  id="permitNumberctrl"
                  class="form-control shadow-none"
                  placeholder="Enter Permit Number"
                  formControlName="permitNumber"
                />
              </div>
            </div>
            <div class="col-lg-3 col-xl-3 col-sm-6 col-12 col-md-4">
              <div class="form-group accountsinp mb-3">
                <label for="">Policy Number</label>
                <input
                  type="text"
                  id="policyNumberctrl"
                  class="form-control shadow-none"
                  placeholder="Enter Policy Number"
                  formControlName="policyNumber"
                />
              </div>
            </div>
            <div class="col-lg-3 col-xl-3 col-sm-6 col-12 col-md-4">
              <div class="form-group accountsinp mb-3">
                <label for="">City</label>
                <input
                  type="text"
                  id="cityctrl"
                  class="form-control shadow-none"
                  placeholder="Enter City"
                  formControlName="city"
                />
              </div>
            </div>
            <div class="col-lg-3 col-xl-3 col-sm-6 col-12 col-md-4">
              <div class="form-group accountsinp mb-3">
                <label for="">Permit Due Date</label>
                <input
                  type="date"
                  id="permitDueDatectrl"
                  class="form-control shadow-none"
                  placeholder="Enter Permit Due Date"
                  formControlName="permitDueDate"
                />
              </div>
            </div>
            <div class="col-lg-3 col-xl-3 col-sm-6 col-12 col-md-4">
              <div class="form-group accountsinp mb-3">
                <label for="">Permit 5 Years Due Date</label>
                <input
                  type="date"
                  id="permitYearsDueDatectrl"
                  class="form-control shadow-none"
                  placeholder="Enter Permit 5 Years Due Date"
                  formControlName="permitYearsDueDate"
                />
              </div>
            </div>
            <div class="col-lg-3 col-xl-3 col-sm-6 col-12 col-md-4">
              <div class="form-group accountsinp mb-3">
                <label for="">Purchase Date</label>
                <input
                  type="date"
                  id="purchaseDatectrl"
                  class="form-control shadow-none"
                  placeholder="Enter Purchase Date"
                  formControlName="purchaseDate"
                />
              </div>
            </div>

            <div class="col-lg-3 col-xl-3 col-sm-6 col-12 col-md-4">
              <div class="form-group accountsinp mb-3">
                <label for="">Road Tax Date</label>
                <input
                  type="date"
                  id="roadTaxDatectrl"
                  class="form-control shadow-none"
                  placeholder="Enter Road Tax Date"
                  formControlName="roadTaxDate"
                />
              </div>
            </div>
            <div class="col-lg-3 col-xl-3 col-sm-6 col-12 col-md-4">
              <div class="form-group accountsinp mb-3">
                <label for="">Insurance Due Date</label>
                <input
                  type="date"
                  id="insuranceDueDatectrl"
                  class="form-control shadow-none"
                  placeholder="Enter Insurance Due Date"
                  formControlName="insuranceDueDate"
                />
              </div>
            </div>
            <div class="col-lg-3 col-xl-3 col-sm-6 col-12 col-md-4">
              <div class="form-group accountsinp mb-3">
                <label for="">Fitness Due Date</label>
                <input
                  type="date"
                  id="fitnessDueDatectrl"
                  class="form-control shadow-none"
                  placeholder="Enter Fitness Due Date"
                  formControlName="fitnessDueDate"
                />
              </div>
            </div>

            <div class="col-lg-3 col-xl-3 col-sm-6 col-12 col-md-4">
              <div class="form-group accountsinp mb-3">
                <label for="">Pollution Expiry Date</label>
                <input
                  type="date"
                  id="pollutionExpiryDatectrl"
                  class="form-control shadow-none"
                  placeholder="Enter Pollution Expiry Date"
                  formControlName="pollutionExpiryDate"
                />
              </div>
            </div>
            <div class="col-xl-12 mb-3">
              <div class="detailsBox">
                <h4>Upload Document</h4>
                <p>
                  Uploads are restricted to image and PDF file formats only.
                </p>

                <div class="row">
                  <!-- PERMIT -->
                  <div class="col-lg-2 col-md-4 col-6">
                    <label>Permit</label>

                    <input
                      type="file"
                      accept="image/*,.pdf"
                      *ngIf="!permitPreview"
                      (change)="fileChangeEventPermit($event)"
                      id="permitctrl"
                      class="d-none"
                    />

                    <label
                      *ngIf="!permitPreview"
                      for="permitctrl"
                      class="uploadimgNewDesign"
                    >
                      <img
                        src="../../../../assets/images/svg/uploadImageNew.svg"
                      />
                      <h5>Upload Permit</h5>
                    </label>

                    <ng-container
                      *ngIf="permitPreview"
                      [ngTemplateOutlet]="filePreview"
                      [ngTemplateOutletContext]="{
                        preview: permitPreview,
                        resetKey: 'permit',
                      }"
                    ></ng-container>
                  </div>

                  <!-- RC COPY -->
                  <div class="col-lg-2 col-md-4 col-6">
                    <label>RC Copy</label>

                    <input
                      type="file"
                      accept="image/*,.pdf"
                      *ngIf="!rcPreview"
                      (change)="fileChangeEventRC($event)"
                      id="RCCopyctrl"
                      class="d-none"
                    />

                    <label
                      *ngIf="!rcPreview"
                      for="RCCopyctrl"
                      class="uploadimgNewDesign"
                    >
                      <img
                        src="../../../../assets/images/svg/uploadImageNew.svg"
                      />
                      <h5>Upload RC</h5>
                    </label>

                    <ng-container
                      *ngIf="rcPreview"
                      [ngTemplateOutlet]="filePreview"
                      [ngTemplateOutletContext]="{
                        preview: rcPreview,
                        resetKey: 'rc',
                      }"
                    ></ng-container>
                  </div>

                  <!-- INSURANCE -->
                  <div class="col-lg-2 col-md-4 col-6">
                    <label>Insurance</label>

                    <input
                      type="file"
                      accept="image/*,.pdf"
                      *ngIf="!insuracePreview"
                      (change)="fileChangeEventInsurance($event)"
                      id="insurancectrl"
                      class="d-none"
                    />

                    <label
                      *ngIf="!insuracePreview"
                      for="insurancectrl"
                      class="uploadimgNewDesign"
                    >
                      <img
                        src="../../../../assets/images/svg/uploadImageNew.svg"
                      />
                      <h5>Upload Insurance</h5>
                    </label>

                    <ng-container
                      *ngIf="insuracePreview"
                      [ngTemplateOutlet]="filePreview"
                      [ngTemplateOutletContext]="{
                        preview: insuracePreview,
                        resetKey: 'insurance',
                      }"
                    ></ng-container>
                  </div>

                  <!-- PERMIT 5 YEARS -->
                  <div class="col-lg-2 col-md-4 col-6">
                    <label>Permit 5 Years</label>

                    <input
                      type="file"
                      accept="image/*,.pdf"
                      *ngIf="!permit5yPreview"
                      (change)="fileChangeEventPermitYears($event)"
                      id="permitYearsctrl"
                      class="d-none"
                    />

                    <label
                      *ngIf="!permit5yPreview"
                      for="permitYearsctrl"
                      class="uploadimgNewDesign"
                    >
                      <img
                        src="../../../../assets/images/svg/uploadImageNew.svg"
                      />
                      <h5>Upload Permit 5Y</h5>
                    </label>

                    <ng-container
                      *ngIf="permit5yPreview"
                      [ngTemplateOutlet]="filePreview"
                      [ngTemplateOutletContext]="{
                        preview: permit5yPreview,
                        resetKey: 'permit5y',
                      }"
                    ></ng-container>
                  </div>

                  <!-- ROAD TAX -->
                  <div class="col-lg-2 col-md-4 col-6">
                    <label>Road Tax</label>

                    <input
                      type="file"
                      accept="image/*,.pdf"
                      *ngIf="!roadTexPreview"
                      (change)="fileChangeEventRoadTax($event)"
                      id="roadTaxctrl"
                      class="d-none"
                    />

                    <label
                      *ngIf="!roadTexPreview"
                      for="roadTaxctrl"
                      class="uploadimgNewDesign"
                    >
                      <img
                        src="../../../../assets/images/svg/uploadImageNew.svg"
                      />
                      <h5>Upload Road Tax</h5>
                    </label>

                    <ng-container
                      *ngIf="roadTexPreview"
                      [ngTemplateOutlet]="filePreview"
                      [ngTemplateOutletContext]="{
                        preview: roadTexPreview,
                        resetKey: 'roadtax',
                      }"
                    ></ng-container>
                  </div>

                  <!-- FITNESS -->
                  <div class="col-lg-2 col-md-4 col-6">
                    <label>Fitness</label>

                    <input
                      type="file"
                      accept="image/*,.pdf"
                      *ngIf="!fitnessPreview"
                      (change)="fileChangeEventFitness($event)"
                      id="fitnessctrl"
                      class="d-none"
                    />

                    <label
                      *ngIf="!fitnessPreview"
                      for="fitnessctrl"
                      class="uploadimgNewDesign"
                    >
                      <img
                        src="../../../../assets/images/svg/uploadImageNew.svg"
                      />
                      <h5>Upload Fitness</h5>
                    </label>

                    <ng-container
                      *ngIf="fitnessPreview"
                      [ngTemplateOutlet]="filePreview"
                      [ngTemplateOutletContext]="{
                        preview: fitnessPreview,
                        resetKey: 'fitness',
                      }"
                    ></ng-container>
                  </div>

                  <!-- OWNER PAN -->
                  <div class="col-lg-2 col-md-4 col-6">
                    <label>Owner PAN</label>

                    <input
                      type="file"
                      accept="image/*,.pdf"
                      *ngIf="!ownerpanPreview"
                      (change)="fileChangeEventOwnerPancard($event)"
                      id="ownerPancardctrl"
                      class="d-none"
                    />

                    <label
                      *ngIf="!ownerpanPreview"
                      for="ownerPancardctrl"
                      class="uploadimgNewDesign"
                    >
                      <img
                        src="../../../../assets/images/svg/uploadImageNew.svg"
                      />
                      <h5>Upload PAN</h5>
                    </label>

                    <ng-container
                      *ngIf="ownerpanPreview"
                      [ngTemplateOutlet]="filePreview"
                      [ngTemplateOutletContext]="{
                        preview: ownerpanPreview,
                        resetKey: 'ownerpan',
                      }"
                    ></ng-container>
                  </div>

                  <!-- OWNER AADHAAR -->
                  <div class="col-lg-2 col-md-4 col-6">
                    <label>Owner Aadhaar</label>

                    <input
                      type="file"
                      accept="image/*,.pdf"
                      *ngIf="!owneradharPreview"
                      (change)="fileChangeEventOwnerAadharcard($event)"
                      id="ownerAadharCardctrl"
                      class="d-none"
                    />

                    <label
                      *ngIf="!owneradharPreview"
                      for="ownerAadharCardctrl"
                      class="uploadimgNewDesign"
                    >
                      <img
                        src="../../../../assets/images/svg/uploadImageNew.svg"
                      />
                      <h5>Upload Aadhaar</h5>
                    </label>

                    <ng-container
                      *ngIf="owneradharPreview"
                      [ngTemplateOutlet]="filePreview"
                      [ngTemplateOutletContext]="{
                        preview: owneradharPreview,
                        resetKey: 'owneradhar',
                      }"
                    ></ng-container>
                  </div>

                  <!-- CANCELLED CHEQUE -->
                  <div class="col-lg-2 col-md-4 col-6">
                    <label>Cancelled Cheque</label>

                    <input
                      type="file"
                      accept="image/*,.pdf"
                      *ngIf="!cancelledChequePreview"
                      (change)="fileChangeEventCancelledCheque($event)"
                      id="cancelledChequectrl"
                      class="d-none"
                    />

                    <label
                      *ngIf="!cancelledChequePreview"
                      for="cancelledChequectrl"
                      class="uploadimgNewDesign"
                    >
                      <img
                        src="../../../../assets/images/svg/uploadImageNew.svg"
                      />
                      <h5>Upload Cheque</h5>
                    </label>

                    <ng-container
                      *ngIf="cancelledChequePreview"
                      [ngTemplateOutlet]="filePreview"
                      [ngTemplateOutletContext]="{
                        preview: cancelledChequePreview,
                        resetKey: 'cancheck',
                      }"
                    ></ng-container>
                  </div>
                </div>
              </div>
            </div>

            <a #showSlip [href]="slipURL" target="_blank"></a>
            <div class="col-md-12 text-end">
              <button
                class="btn btn-outline-dark"
                type="button"
                (click)="resetForm()"
                mat-raised-button
              >
                Reset
              </button>
              <button class="btn btn-dark ms-2" type="submit" mat-raised-button>
                Add Now
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

<ng-template #filePreview let-preview="preview" let-resetKey="resetKey">
  <div class="viewImage">
    <div class="imgBoxp">
      <button class="resetImg" (click)="resetimg(resetKey)">
        <i class="fa-solid fa-xmark"></i>
      </button>

      <!-- IMAGE -->
      <a
        *ngIf="preview.type.startsWith('image/')"
        [href]="preview.url"
        target="_blank"
      >
        <img [src]="preview.url" />
      </a>

      <!-- PDF -->
      <div
        class="d-flex flex-column align-items-center h-100 justify-content-center gap-3"
        *ngIf="preview.type === 'application/pdf'"
      >
        <i class="fa-solid fa-file-pdf fa-6x text-danger flex-grow"></i>
        <a [href]="preview.url" target="_blank" class="pdf-preview text-center">
          <p class="mt-1">{{ preview.name }}</p>
        </a>
      </div>
    </div>
  </div>
</ng-template>
